// extracted by mini-css-extract-plugin
export default {"sidebar":"FoD7v kDaQN","item":"KpQYb uSVJz F4kdQ KL0Gm jKcvR","icon":"MPFu8","selected":"oeNrQ","name":"tno0I AfLf3 gfZK6"};